import { createContext, useReducer } from 'react';

import { useReducer as devUseReducer } from 'reinspect';

import { environment } from '../../environment';

export const StoreContext = createContext();

function StoreProvider({ reducer, initialState = {}, children }) {
  const [store, dispatch] = useReducer(reducer, initialState);
  const [devStore, devDispatch] = devUseReducer(reducer, initialState, state => state, 'redCarpet');
  const isDev = environment().env === 'dev' || environment().env === 'local';

  const sharedValue = {
    store: isDev ? devStore : store,
    dispatch: isDev ? devDispatch : dispatch
  };

  return <StoreContext.Provider value={sharedValue}>{children}</StoreContext.Provider>;
}

export default StoreProvider;
